<template>
  <header>
    <v-app-bar-nav-icon class="d-xl-none d-lg-none d-xl-flex" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-navigation-drawer app width="270px" v-model="drawer">
      <div class="logo_list">
        <div class="logo">
          <img src="@/assets/logo1.png">
        </div>
      </div>
      <div class="menu_list">
        <ul style="width:90%; margin:auto">
          <li v-if="manage_report == true" @click="get_data">
            <router-link class="link_menu" to="/" exact :class="{'router-link-active': $route.path == '/customerwiththemostorders'}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon size="36">mdi-chart-bar</v-icon>
                </div>
                <div class="title_menu">
                  <div>รายงาน</div>
                  <div>Report</div>
                </div>
              </div>
            </router-link>
          </li>
          <li v-if="manage_user == true" @click="get_data">
            <router-link class="link_menu" to="/user">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon size="36">mdi-account-multiple</v-icon>
                </div>
                <div class="title_menu">
                  <div>สมาชิก</div>
                  <div>User</div>
                </div>
              </div>
            </router-link>
          </li>
          <li v-if="manage_inventory == true" @click="get_data">
            <router-link class="link_menu" to="/warehouse" :class="{'router-link-active': $route.path == '/inventorysetting' || $route.path == '/categorysetting' || $route.path == '/processsetting' || $route.path == '/settingcolorchart' || $route.path == '/settingrowmaterial' || $route.path == '/settingcolorchart/addcolorchart' || $route.path == '/settingcolorchart/editcolorchart/' + this.$route.params.id || $route.path == '/settingrowmaterial/addnaturalrawmaterial' || $route.path == '/settingrowmaterial/editnaturalrawmaterial/' + this.$route.params.id || $route.path == '/settingrowmaterial/detailnaturalrawmaterial/' + this.$route.params.id || $route.path == '/settingrowmaterial/addaccessories' || $route.path == '/settingrowmaterial/editaccessories/'+ this.$route.params.id || $route.path == '/settingrowmaterial/detailaccessories/'+ this.$route.params.id || $route.path == '/packagesetting' || $route.path == '/packagesetting/addgiftbox' || $route.path == '/packagesetting/editgiftbox/' + this.$route.params.id || $route.path == '/packagesetting/costhistory/' + this.$route.params.back_id || $route.path == '/packagesetting/detailgiftbox/' + this.$route.params.id || $route.path == '/mailerboxsetting' || $route.path == '/certificatesetting' || $route.path == '/mailerboxsetting/addmailbox' || $route.path == '/mailerboxsetting/editmailbox/' + this.$route.params.id || $route.path == '/certificatesetting/addbrandcontact' || $route.path == '/certificatesetting/editbrandcontact/' + this.$route.params.id || $route.path == '/currencyexchange' || $route.path == '/manageproduct' || $route.path == '/manageproduct/addregularproduct' || $route.path == '/manageproduct/addregularproduct/addregularproductassem' || $route.path == '/commercialbanks' || $route.path == '/collectionproduct' || $route.path == '/addproductcollection' || $route.path == '/editproductcollection' || $route.path == '/detailproductcollection' || $route.path == '/gallery' || $route.path == '/productgallery' || $route.path == '/naturalmaterialsgallery' || $route.path == '/giftboxgallery' || $route.path == '/colorchartgallery' || $route.path == '/photofromcustomergallery' || $route.path == '/photossenttocustomergallery' || $route.path == '/flowergallery' || $route.path == '/productpricelist' || $route.path == '/managenewproduct' || $route.path == '/manageproduct/editregularproduct/' + this.$route.params.id || $route.path == '/manageproduct/detailregularproduct/' + this.$route.params.id || $route.path == '/manageproduct/pricingdetailproductregular/' + this.$route.params.id || $route.path == '/manageproduct/addregularproductcomponentpart' || $route.path == '/manageproduct/editregularproductcomponentpart/' + this.$route.params.id || $route.path == '/manageproduct/detailregularproductcomponentpart/' + this.$route.params.id || $route.path == '/manageproduct/pricingdetailproductregularcomponentpart/' + this.$route.params.id || $route.path == '/manageproduct/addregularproductaccessoriepart' || $route.path == '/manageproduct/editregularproductaccessoriepart/' + this.$route.params.id || $route.path == '/manageproduct/detailregularproductaccessoriepart/' + this.$route.params.id || $route.path == '/manageproduct/pricingdetailproductregularaccessoriepart/' + this.$route.params.id || $route.path == '/managecloseproduct' || $route.path == '/manageproduct/pricingdetailproductregular/' + this.$route.params.id + '/' + this.$route.params.id_viewall || $route.path == '/manageproduct/pricingdetailproductregular/' + this.$route.params.id + '/' + this.$route.params.id_viewall + '/' + this.$route.params.id_infor}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon size="36">mdi-package-variant-closed</v-icon>
                </div>
                <div class="title_menu">
                  <div>คลัง</div>
                  <div>Inventory</div>
                </div>
              </div>
            </router-link>
          </li>
          <li v-if="manage_stock == true" @click="get_data">
            <router-link class="link_menu" to="/stock/main" :class="{'router-link-active': $route.path == '/stock/stockhistory' || $route.path == '/stock/checkinformation/' + this.$route.params.id || $route.path == '/stock/stockdetail/' + this.$route.params.id || $route.path == '/stock/stockcreate' || $route.path == '/stock/stockcount' || $route.path == '/stock/storecountstock' || $route.path == '/stock/storecreatestock' || $route.path == '/stock/storecheckstock/' + this.$route.params.id || $route.path == '/stock/storedetailstock/' + this.$route.params.id}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon size="36">mdi-package</v-icon>
                </div>
                <div class="title_menu">
                  <div>นับสต๊อก</div>
                  <div>Count Stock</div>
                </div>
              </div>
            </router-link>
          </li>
          <li v-if="manage_buy == true" @click="get_data">
            <router-link class="link_menu" to="/ordermain" :class="{'router-link-active': $route.path == '/orderpuchaseorder' || $route.path == '/orderpuchaseordercompany' || $route.path == '/orderpuchaseorder/detailorderpuchasecustomer/' + this.$route.params.id || $route.path == '/orderpuchaseorder/editorderpuchasecustomer/' + this.$route.params.id || $route.path == '/orderpuchaseorder/addorderpuchasecustomer' || $route.path == '/orderpuchaseordercompany/addorderpuchasecompany' || $route.path == '/orderpuchaseordercompany/detailorderpuchasecompany/' + this.$route.params.id}">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon size="36">mdi-cart-outline</v-icon>
                </div>
                <div class="title_menu">
                  <div>ซื้อ</div>
                  <div>Ordering</div>
                </div>
              </div>
            </router-link>
          </li>
          <li v-if="manage_sell == true" @click="get_data">
            <router-link class="link_menu" to="/salemain">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon size="36">mdi-cash-multiple</v-icon>
                </div>
                <div class="title_menu">
                  <div>ขาย</div>
                  <div>Sale</div>
                </div>
              </div>
            </router-link>
          </li>
          <!-- <li>
            <router-link class="link_menu" to="/debtor">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon size="36">mdi-currency-thb</v-icon>
                </div>
                <div class="title_menu">
                  <div>ลูกหนี้</div>
                  <div>Debtor</div>
                </div>
              </div>
            </router-link>
          </li> -->
          <li @click="get_data">
            <router-link class="link_menu" to="/profile_emp">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon size="36">mdi-account-circle</v-icon>
                </div>
                <div class="title_menu">
                  <div>ข้อมูลส่วนตัว</div>
                  <div>Personal Info.</div>
                </div>
              </div>
            </router-link>
          </li>
          <li @click="get_data">
            <div class="link_menu" style="cursor:pointer;" @click="logout()">
              <div class="d-flex card_menu py-2">
                <div class="icon_menu">
                  <v-icon size="36">mdi-logout</v-icon>
                </div>
                <div class="title_menu">
                  <div>ออกจากระบบ</div>
                  <div>Log Out</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </v-navigation-drawer>
  </header>
</template>

<script>
import Swal from "sweetalert2";
import {HTTP} from "@/axios";

export default {
  name: "Menu",
  data() {
    return {
      drawer: null,
      manage_report: null,
      manage_user: null,
      manage_inventory: null,
      manage_stock: null,
      manage_buy: null,
      manage_sell: null,
    }
  },
  methods: {
    get_data() {
      if(this.$store.state.access_token !== null) {
        let config = {
          headers: {
            // 'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${this.$store.state.token}`
          }
        };
        HTTP.get('/v1/admin/get/permission' , config)
        .then((res) => {
          if(res.data.successful === true) {
            this.manage_report = res.data.data.manage_report
            this.manage_user = res.data.data.manage_user
            this.manage_inventory = res.data.data.manage_inventory
            this.manage_stock = res.data.data.manage_stock
            this.manage_buy = res.data.data.manage_buy
            this.manage_sell = res.data.data.manage_sell
          }
        })
      }
    },
    async logout() {
      await Swal.fire({
        title: 'คุณต้องการออกจากระบบหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed === true) {
          this.$store.commit('logout_success')
          this.$router.push('/login')
        }
      });
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.logo_list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.logo_list>.logo {
  padding-top: 30px;
  width: 180px;
}

.logo_list>.logo>img {
  max-width: 100%;
}

.menu_list>ul {
  list-style: none;
  padding: 0;
}

.menu_list>ul>li {
  padding: 5px;
}

.link_menu {
  text-decoration: none;
  display: block;
  color: #565656;
  border-radius: 4px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
}

.icon_menu {
  margin-left: 10px;
  align-self: center;
}

.title_menu {
  margin-left: 10px;
}

.link_menu:hover {
  background-image: linear-gradient(to right, #A3802E, #c1a75b, #c1a25f);
  transition: 0.1s !important;
}

.link_menu:hover>.card_menu>.icon_menu>i,
.link_menu:hover>.card_menu>.title_menu {
  color: #ffffff;
  transition: 0.1s !important;
}

.router-link-active {
  background-image: linear-gradient(to right, #A3802E, #c1a75b, #c1a25f);
  transition: 0.1s !important;
}

.router-link-active>.card_menu>.icon_menu>i,
.router-link-active>.card_menu>.title_menu {
  color: #ffffff;
  transition: 0.1s !important;
}
</style>
